<template>
  <div class="ccontainer">
    <div class="wrapper">
      <div class="header__logo">
        <div class="container">
          <a href="/" class="header__logo-link">
            <img
              class="header__logo-image"
              style=""
              src="//cdn.shopify.com/s/files/1/0596/1547/7862/files/logo-aozama-blanco.png?width=280&height=132"
              alt="Aozama"
            />
          </a>
        </div>
      </div>
      <div class="product-detail devices-detail container">
        <!-- Breadcrumb -->
        <div class="row">
          <div class="col">
            <ol class="breadcrumb">
              <li>
                <a href="/">Cash Market</a>
              </li>
              <li>
                <a href="/#!/brand-list/{{offer.service_type_id}}">{{
                  offer.categories.name
                }}</a>
              </li>
              <li class="active">{{ offer.title }}</li>
            </ol>
          </div>
        </div>

        <div class="row devices-detail__container">
          <h2>{{ offer.title }}</h2>
          <!-- Product Detail Image Gallery -->
          <div class="col-lg-6 p-l-0 product__big-img-gallery">
            <div class="featured-image">
              <div class="offer--cards__bg product-photo" id="ProductPhoto">
                <img
                  id="ProductPhotoImg"
                  class="zoom_mouse product_variant_image"
                  src="{{urlApi+offer.image.path}}"
                />
              </div>
            </div>
            <div class="shop-product__small-image-gallery-wrapper">
              <div
                class="
                  shop-product__small-image-gallery-slider
                  owl-carousel owl-loaded owl-drag
                "
                id="ProductThumbs"
              >
                <div class="owl-stage-outer">
                  <div
                    class="owl-stage"
                    style="
                      transform: translate3d(0px, 0px, 0px);
                      transition: all 0s ease 0s;
                      width: 575px;
                    "
                  >
                    <!-- Items 1 -->
                    <div class="carousel-item" v-for="image in offer.images">
                      <div class="single-image">
                        <a
                          class="product-single__thumbnail"
                          href="javascript:void(0);"
                          @click="changeImage(image)"
                        >
                          <img
                            src="{{urlApi+image.path}}"
                            alt="{{image.title}}"
                          />
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="owl-nav">
                  <div class="owl-prev">
                    <i class="ti-angle-left"></i>
                  </div>
                  <div class="owl-next">
                    <i class="ti-angle-right"></i>
                  </div>
                </div>
                <div class="owl-dots disabled"></div>
              </div>
            </div>
          </div>

          <div class="specs-side">
            <!-- Marca -->
            <div class="cash-product__buttons">
              <button class="btn btn-transparent" type="button">
                <span class="cart-text" style="font-size: 2rem">
                  Marca: {{ offer.brands.name }}</span
                >
              </button>
            </div>

            <!-- Calificar Estrellas -->
            <div class="stars-wrap">
              <div class="star" v-for="n in 5" :key="n">
                <img
                  v-if="offer.starts < n"
                  src="/images/offes-news-img/empty-star.png"
                />
                <img v-else src="/images/offes-news-img/star.png" />
              </div>
              <label class="number-of-reviews">5,356</label>
            </div>

            <!-- Calificar Producto -->
            <div class="cash-product__buttons">
              <button
                class="btn btn-transparent"
                type="button"
                data-toggle="modal"
                data-target="#commentsModal"
              >
                <span class="cart-text">Calificar producto</span>
              </button>
            </div>

            <!-- Valor -->
            <div class="value-group">
              <div class="regular-title">Valor:</div>
              <div class="price-value">
                <span class="currency-wrap">RD</span>
                <span class="price">{{ offerAmount | currency }}</span>
              </div>
            </div>

            <div class="prices-plan" v-show="offer.type == 0">
              <div class="value-group">
                <div class="regular-title">Monto Pre-aprobado:</div>
                <div class="value-with-background gray">
                  RD {{ preApprovedAmount | currency }}
                </div>
              </div>

              <div class="value-group">
                <div class="regular-title">Monto Disponible:</div>
                <div class="value-with-background gray">
                  RD {{ creditLimit.available_amount | currency }}
                </div>
              </div>

              <div class="value-group">
                <div class="regular-title">Monto Plan de Pagos:</div>
                <div class="value-with-background gray">
                  RD {{ form.next_due | currency }}
                </div>
              </div>

              <div class="value-group">
                <div class="regular-title">Cuotas Plan de Pago:</div>
                <div class="value-with-background">
                  <select v-model="form.total_splits" class="form-control">
                    <option
                      v-for="day in duesArrays"
                      v-bind:value="day"
                      v-show="day >= min_split"
                    >
                      {{ day }} Cuotas
                    </option>
                  </select>
                </div>
              </div>

              <div class="value-group">
                <div class="regular-title">Monto Financiado:</div>
                <div class="value-with-background gray">
                  <input
                    type="text"
                    class="form-control"
                    v-model="form.amount_financed"
                  />
                </div>
              </div>

              <div class="value-group">
                <div class="regular-title">Cantidad:</div>
                <div class="value-with-background gray">
                  <select
                    v-model="form.count"
                    class="form-control"
                    @change="changesCount()"
                  >
                    <option value="1">1</option>
                    <option value="2">2</option>
                    <option value="3">3</option>
                    <option value="4">4</option>
                    <option value="5">5</option>
                    <option value="6">6</option>
                    <option value="7">7</option>
                    <option value="8">8</option>
                    <option value="9">9</option>
                    <option value="10">10</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="prices-plan" v-show="offer.type == 1">
              <div class="value-group">
                <div class="regular-title">Monto:</div>
                <div class="value-with-background gray">
                  <input
                    type="text"
                    v-model="form.request_amount"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="value-group">
                <div class="regular-title">Contrato ID:</div>
                <div class="value-with-background gray">
                  <input
                    type="text"
                    v-model="form.contract"
                    class="form-control"
                  />
                </div>
              </div>
              <div class="value-group">
                <div class="regular-title">Información Adicional:</div>
                <div class="value-with-background gray">
                  <textarea
                    v-model="form.description"
                    class="text-area"
                  ></textarea>
                </div>
              </div>
            </div>

            <!--<div class="value-group">
                            <div class="dragged-value-wrap">
                                <div class="value-group">
                                    <div class="regular-title">Monto abono del cliente:</div>
                                </div>
                                <green-dragger :max="this.form.total" :current="form.invoice_payment" :progress="progress" :allowDrag="true" @value-changed="reportChange"></green-dragger>
                            </div>
            </div>-->

            <div class="request-product-btn" @click="sumitRequest()">
              Solicitar
            </div>
          </div>
        </div>

        <div class="row devices-detail__info">
          <!--  Productos relacionados -->
          <div class="related-products" v-show="tops.length > 1">
            <h3>Productos relacionados</h3>
            <!-- Slide Top Offers -->
            <div class="splide">
              <div class="splide__track">
                <ul class="splide__list tops">
                  <li class="splide__slide" v-for="article in tops">
                    <a
                      href="/#!/{{details}}/{{article.id}}"
                      class="splide__slide__container"
                    >
                      <img
                        :src="
                          'https://api.cashdepotint.com/' +
                          article.images[0].path
                        "
                      />
                    </a>
                    <span>{{ article.title }}</span>
                    <label class="top-offers__price currency-price"
                      >RD$ {{ article.amount | currency }}</label
                    >
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- Información de producto -->
          <div class="col offer--cards__bg">
            <div class="devices-info">
              <h3>Información de producto</h3>
              {{ offer.description }}
            </div>
          </div>
        </div>

        <br />

        <!-- Reviews -->
        <div class="row review-clients">
          <div class="col">
            <!-- <h2>Opiniones de clientes</h2> -->
            <!-- Opinion #1 -->
            <div
              class="review-container offer--cards__bg pendding-comments"
              v-for="comment in queueComments"
            >
              <div class="row">
                <div class="col-md-2 review-container__users">
                  <img src="{{comment.avatar}}" class="img-circle" />
                  <span>{{ comment.user }}</span>
                  <div class="classification--stars">
                    <img src="/images/offes-news-img/stars-orange.png" />
                  </div>
                </div>

                <div class="col-md-8 review-container__text">
                  <h1>Pendiente de Aprobación</h1>
                  {{ comment.content }}
                </div>
              </div>
            </div>

            <div
              class="review-container offer--cards__bg"
              v-for="comment in comments"
            >
              <div class="row">
                <div class="col-md-2 review-container__users">
                  <img src="{{comment.avatar}}" class="img-circle" />
                  <span>{{ comment.user }}</span>
                  <div class="classification--stars">
                    <img src="/images/offes-news-img/stars-orange.png" />
                  </div>
                </div>

                <div class="col-md-8 review-container__text">
                  {{ comment.content }}
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="cash-product__buttons col-md-4">
            <button
              class="btn cancel-btn"
              type="button"
              data-toggle="modal"
              data-target="#commentsModal">
              <span class="cart-text">Dejar una Opinion</span>
            </button>
          </div> -->
        </div>
        <br />
      </div>
    </div>

    <div class="modal fade" id="commentsModal" role="dialog">
      <div class="modal-dialog modal-opinion">
        <!-- Modal content-->
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal">
              &times;
            </button>
            <h4 class="modal-title">Compartir opinión</h4>
          </div>
          <div class="modal-body">
            <div class="value-group">
              <div class="regular-title">Calificación general</div>
              <div class="value-radio value-with-background gray">
                <label class="container start-chk">
                  <input
                    id="r1d"
                    type="radio"
                    checked="checked"
                    name="radio"
                    v-model="commentsForm.starts"
                    value="1"
                  />
                  <span class="checkmark"></span>
                  1
                </label>
                <label class="container start-chk">
                  <input
                    id="r2d"
                    type="radio"
                    name="radio"
                    v-model="commentsForm.starts"
                    value="2"
                  />
                  <span class="checkmark"></span>
                  2
                </label>
                <label class="container start-chk">
                  <input
                    id="r3d"
                    type="radio"
                    name="radio"
                    v-model="commentsForm.starts"
                    value="3"
                  />
                  <span class="checkmark"></span>
                  3
                </label>
                <label class="container start-chk">
                  <input
                    id="r4d"
                    type="radio"
                    name="radio"
                    v-model="commentsForm.starts"
                    value="4"
                  />
                  <span class="checkmark"></span>
                  4
                </label>
                <label class="container start-chk">
                  <input
                    id="r5d"
                    type="radio"
                    name="radio"
                    v-model="commentsForm.starts"
                    value="5"
                  />
                  <span class="checkmark"></span>
                  5
                </label>
              </div>
            </div>
            <div class="value-group">
              <div class="regular-title">Escribir tu opinión</div>
              <div class="value-with-background gray">
                <textarea
                  style="margin: 0px; width: 432px; height: 164px"
                  v-model="commentsForm.content"
                ></textarea>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button type="button" class="btn cancel-btn" data-dismiss="modal">
              Cancelar
            </button>
            <button
              type="button"
              class="btn submit-btn"
              data-dismiss="modal"
              @click="AddComments()"
            >
              Enviar
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ProductDetailDevices",
  data() {
    return {
      urlApi: "https://api.cashdepotint.com/",
      url: "https://app.cashdepotint.com/",
      details: "product-details",
      offer: {
        title: "",
        description: "",
        amount: "",
        images: [],
        image: null,
        starts: 5,
      },
      newComment: "",
      commentsForm: {
        content: "",
        users_id: null,
        offer_id: null,
        starts: 5,
      },
      queueComments: [],
      user_id: 0,
      duesArrays: [],
      creditLimit: {
        monthlyIncome: 0,
        monthlyConsumption: 0,
        currentLoansConsumption: 0,
        balance: 0,
        employee_id: null,
        available_amount: 0,
      },
      form: {
        next_due: 0,
        employee_id: 0,
        total_splits: 1,
        invoice_payment: 0,
        total: 0,
        amount_financed: 0,
        request_amount: "",
        contract: "",
        description: "",
        shop_id: 1,
        offer_id: 1,
        count: 1,
      },
      progress: 100,
      progressDues: 0,
      min_split: 1,
      preApprovedAmount: 0,
      offerAmount: 0,
      comments: [],
      queueComments: [],
      tops: [],
    };
  },
  created() {
    this.id = this.$route.params.id;
    this.form.employee_id = window.localStorage.getItem("employee_id");
    this.commentsForm.users_id = window.localStorage.getItem("user_id");
    this.commentsForm.offer_id = this.id;
    this.user_id = window.localStorage.getItem("user_id");
    this.getOffer();
    this.getTops();
    this.getComments();
    this.myComments();
    this.getCreditLimit();
  },
  watch: {
    "form.total_splits": function (val) {
      if (val < this.min_split) {
        this.form.total_splits = this.min_split;
        //console.log(this.form.total_splits);
        sweetAlert(
          "Oops...",
          "El minimo de cuotas para este producto es " + this.min_split,
          "error"
        );
        return;
      }
      this.cal();
    },
    "form.amount_financed": function (val) {
      this.amountFinanced();
      this.getMinSplit();
    },
  },
  methods: {
    changesCount() {
      this.form.count = Math.round(this.form.count);
      this.form.amount_financed = this.offerAmount =
        this.offer.amount * this.form.count;

      this.amountFinanced();
      this.getMinSplit();
      this.cal();
    },
    amountFinanced() {
      var amount_financed = Math.round(this.form.amount_financed);
      var available_amount = Math.round(this.creditLimit.available_amount);
      var amount = Math.round(this.offerAmount);

      if (amount_financed > amount) {
        this.form.amount_financed = this.offerAmount;
      }

      if (available_amount < amount) {
        this.form.amount_financed = this.creditLimit.available_amount;
      }

      this.cal();
    },
    getOffer() {
      this.loadingOffers = true;
      this.$http
        .get(
          apiUrl +
            `/offers/${this.id}?relationships=categories,offersProvider,typeDays,images,brands`
        )
        .then((response) => {
          this.offer = response.data;
          this.offer.image = response.data.images[0];
          var i;
          for (i = 1; i <= response.data.fee; i++) {
            this.duesArrays.push(i);
          }
          this.form.amount_financed = this.offer.amount;
          this.form.offer_id = this.offer.id;
          this.offerAmount = this.offer.amount * this.form.count;
          this.cal();
          this.getMinSplit();
        });
    },
    getTops() {
      this.loadingOffers = true;
      this.$http.get(apiUrl + `/offers/${this.id}/related`).then((response) => {
        this.tops = response.data;

        this.$nextTick(() => {
          this.startSlick(".tops");
        });
      });
    },
    getComments() {
      this.$http
        .get(apiUrl + `/comments/offers/${this.id}`)
        .then((response) => {
          //console.log(response);
          this.comments = response.data;
        });
    },
    myComments() {
      this.$http
        .get(apiUrl + `/comments/user-queue/${this.user_id}/${this.id}`)
        .then((response) => {
          this.queueComments = response.data;
          //console.log(response);
        });
    },
    AddComments() {
      if (this.commentsForm.content.length == 0) {
        sweetAlert("Oops...", "Ha ocurrido un error !", "error");
      }

      this.$http({
        emulateJSON: true,
        emulateHTTP: true,
        url: apiUrl + "/comments",
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
        },
        body: this.commentsForm,
      }).then(
        function (response) {
          this.commentsForm.content = "";
          sweetAlert(
            "Success",
            "!Solicitud enviada exitosamente! El comentario estará sujeto a aprobación.",
            "success"
          );
          //location.reload();
        },
        (response) => {
          sweetAlert("Oops...", "Ha ocurrido un error !", "error");
        }
      );
    },
    changeImage(image) {
      this.offer.image = image;
    },
    sumitRequest() {
      if (this.offer.type == 1) {
        this.$http({
          emulateJSON: true,
          emulateHTTP: true,
          url: apiUrl + "/orders/dues-services",
          method: "POST",
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
          body: this.form,
        }).then(
          function (response) {
            sweetAlert(
              "Success",
              "!Solicitud enviada exitosamente! El equipo de CASHDEPOT lo contactará pronto.",
              "success"
            );
            location.reload();
          },
          (response) => {
            sweetAlert("Oops...", "Ha ocurrido un error !", "error");
          }
        );
        //return;
      } else {
        window.localStorage.setItem("next_due", this.form.next_due);
        window.localStorage.setItem("total_splits", this.form.total_splits);
        window.localStorage.setItem(
          "invoice_payment",
          this.form.invoice_payment
        );
        window.localStorage.setItem(
          "amount_financed",
          this.form.amount_financed
        );
        window.localStorage.setItem("count", this.form.count);
        window.location.replace(`/#!/offers/${this.id}/checkout`);
      }
    },
    getCreditLimit() {
      this.$http
        .get(apiUrl + `/employees/${this.form.employee_id}/limit`)
        .then((response) => {
          this.creditLimit = response.data;
          this.creditLimit.available_amount =
            this.creditLimit.limit_of_credit * 1;
          this.cal();
          if (this.creditLimit.available_amount > this.offer.amount) {
            this.form.amount_financed = this.offer.amount;
            this.preApprovedAmount = this.offer.amount;
          } else {
            this.form.amount_financed = this.creditLimit.available_amount;
            this.preApprovedAmount = this.creditLimit.available_amount;
          }
        });
    },
    cal() {
      if (!this.form.employee_id) {
        return;
      }
      this.offerAmount = this.offer.amount * this.form.count;

      if (this.creditLimit.available_amount > this.offerAmount) {
        this.form.invoice_payment =
          (this.offerAmount - this.form.amount_financed) * 1;
        this.preApprovedAmount = this.offerAmount * 1;
      } else {
        var canFinance = this.offerAmount - this.creditLimit.available_amount;
        var heFinace = this.offerAmount - this.form.amount_financed;
        if (heFinace > canFinance) {
          this.form.invoice_payment = canFinance * 1;
          //this.form.amount_financed = canFinance;
        } else {
          this.form.invoice_payment = heFinace * 1;
        }
        this.preApprovedAmount = this.form.invoice_payment;
      }

      var amount = this.offerAmount - this.form.invoice_payment;

      var interes = amount * 0.02;
      var total_splits = this.form.total_splits;
      if (total_splits == 0) {
        total_splits = 1;
      }
      this.form.interest_amount = Number((interes * total_splits).toFixed(2));
      this.form.next_due = Number((amount / total_splits + interes).toFixed(2));
      this.form.total = Number((this.form.next_due * total_splits).toFixed(2));
      this.form.subtotal = this.offerAmount;

      var progress = (this.form.invoice_payment / this.form.total) * 100;
      this.progress = Math.round(progress);

      var progressDues = (total_splits / this.offer.fee) * 100;
      this.progressDues = Math.round(progressDues);
    },
    reportChange: function (value) {
      //console.log(value);
    },
    getMinSplit() {
      let amount = this.offerAmount - this.form.invoice_payment;
      this.$http
        .get(
          apiUrl +
            `/products/super-market/splits/${amount}/${this.form.employee_id}`
        )
        .then((response) => {
          this.min_split = response.data.min_split;
          if (this.form.total_splits < this.min_split) {
            this.form.total_splits = this.min_split;
          }
        });
    },
    startSlick(slickContainer, total = 5) {
      $(slickContainer).slick({
        lazyLoad: "ondemand",
        slidesToShow: total,
        slidesToScroll: 1,
        infinite: true,
        speed: 300,
        adaptiveHeight: true,
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2,
              slidesToScroll: 1,
              infinite: true,
              dots: true,
            },
          },
          {
            breakpoint: 600,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1,
              slidesToScroll: 1,
            },
          },
        ],
      });
    },
  },
};
</script>

<style lang="css" scoped>
.btn.active,
.btn:active {
  box-shadow: none !important;
}

.product-specs-wrap {
  width: 1000px;
  max-width: 1000px;
  margin: 0 auto;
  display: flex;
}

.product-specs-wrap > div {
  width: 50%;
}

.stars-wrap {
  display: flex;
}

.stars-wrap img {
  width: 20px;
  height: 20px;
  margin-right: 5px;
}
.number-of-reviews {
  margin: 3px 0 0 5px;
}

.specs-side {
  padding-left: 25px;
}

.specs-side > h2 {
  text-align: left;
  margin-bottom: 5px;
  font-weight: 900;
}

.value-group {
  display: flex;
  font-size: 13px;
  padding: 10px 0;
  align-items: center;
}

.regular-title {
  margin-right: 7px;
}

.price-value,
.price {
  display: flex;
  align-items: center;
  font-size: 24px;
  color: #cf3917;
}

.price-value > .currency-wrap {
  font-size: 9px;
  margin-right: 5px;
}

.price-value > .decimals {
  font-size: 9px;
  margin-left: 3px;
}

/* Product options */

.key-switch {
  margin-bottom: 8px;
}

.key-switch > .value-group {
  padding-top: 0;
}

.key-switch > .options-wrap {
  display: flex;
  padding-top: 5px;
}

.key-switch > .options-wrap > .option {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  border: 1px dashed #ccc;
  width: 65px;
  font-size: 12px;
  font-weight: 900;
  margin-right: 7px;
  cursor: pointer;
  box-sizing: border-box;
  -webkit-transition: all 0.2s;
  transition: all 0.2s;
}

.key-switch > .options-wrap > .option:hover {
  border: 2px dashed #ccc;
}

.key-switch > .options-wrap > .option.active {
  color: #213f99;
  border: 1px solid #213f99;
}

.key-switch .regular-size-value {
  font-weight: 900;
}

/* Plans style */

.prices-plan {
  display: grid;
  grid-template-columns: auto auto;
  grid-column-gap: 10px;
}

.prices-plan > div {
  display: flex;
  /* width: 50%; */
}

.prices-plan > .value-group {
  flex-flow: column;
  align-items: flex-start;
  width: 100%;
}

.prices-plan .value-group > div {
  width: 100%;
  text-align: left;
}

.prices-plan .value-group .value-with-background {
  border: 2px solid #eee;
  padding: 5px 7px;
  box-sizing: border-box;
  margin-top: 7px;
  font-weight: 900;
}

.prices-plan .value-group .value-with-background.gray {
  background-color: #eee;
}

.request-product-btn {
  margin-top: 10px;
  height: 40px;
  background-color: #38b449;
  border-radius: 4px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 900;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
}

.submit-btn {
  margin-top: 10px;
  height: 40px;
  background-color: #38b449;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 900;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
}

.cancel-btn {
  margin-top: 10px;
  height: 40px;
  background-color: #6c6c6c;
  border-radius: 4px;
  justify-content: center;
  align-items: center;
  color: #fff;
  font-weight: 900;
  text-transform: uppercase;
  font-size: 12px;
  cursor: pointer;
}

/* GALLERY CSS */

.gallery-side {
  padding-right: 25px;
  padding-top: 30px;
}

img {
  max-width: 100%;
}
h1 {
  font-size: 26px;
}
a {
  color: #213f99;
}
a:hover {
  text-decoration: underline;
  color: #213f99;
}
/* Breadcrum */
.breadcrumb {
  margin-bottom: 0px;
  text-transform: capitalize;
}
.breadcrumb li.active {
  color: #000000;
}
.breadcrumb li a {
  color: #898989;
}

/* Classification Star */

.stars--item {
  text-align: left;
  max-width: 150px;
  width: 100%;
  height: 38px;
}
.devices-table {
  margin: 30px 0 15px;
}
.devices-table tr {
  border-bottom: 1px solid #d4d9ddbd;
}
.devices-table td {
  color: #213f99;
}
.devices-info p,
.devices-table tr,
.devices-table td {
  font-size: 16px;
}
.table-header__devices {
  background: #f5f5f5;
  padding: 15px 30px;
}
.product-detail .offer--cards__bg {
  padding: 30px 40px;
}
.offer--cards__bg {
  background: #fff;
  border: 1px solid #ccc;
}
.sign-price,
.currency-price {
  vertical-align: middle;
}
.currency-price {
  font-size: 24px;
}

.cent-price {
  vertical-align: sub;
  margin-left: -5px;
}

.devices-detail__container {
  margin-bottom: 40px;
}

.product-photo {
  text-align: center;
  margin-bottom: 25px;
}

.carousel-item {
  width: auto;
  margin-right: 8px;
  border: 1px solid #ddd;
  background-color: white;
  cursor: pointer;
}

.carousel-item.active {
  border: 2px solid #aaa;
}

.carousel-item img {
  max-height: 75px;
  height: 75px;
  width: auto;
  min-width: 60px;
}

.owl-stage {
  display: flex;
  flex: 1;
  overflow-x: auto;
}

.owl-stage::-webkit-scrollbar {
  display: none;
}

/* Review Clients */

.review-container {
  max-height: 218px;
  height: 100%;
  padding: 0px 40px !important;
  margin: 15px 0 0px;
}

.review-container__users {
  text-align: center;
  padding: 20px;
}

.review-container__users span {
  display: block;
  margin: 15px 0 0px;
  font-size: 16px;
}
.review-container__text {
  padding: 50px 35px 20px;
  font-size: 16px;
  color: #707070;
}

#ProductPhoto {
  max-height: 400px;
  min-height: 500px;
  display: flex;
  justify-content: center;
  align-items: center;
}

#ProductPhoto img {
  max-height: inherit;
  height: inherit;
  width: auto;
}

.direction-wrap {
  display: flex;
  align-items: center;
  width: 40px;
  height: 100%;
  color: #cccc;
  opacity: 0.5;
  cursor: pointer;
}

.direction-wrap.right {
  justify-content: flex-end;
}

.direction-wrap img {
  width: 15px;
  height: auto;
}

#ProductThumbs {
  display: flex;
  align-items: center;
}

.text-area {
  margin: 0px;
  height: 74px;
  width: 366px;
}

/* Modal  */
.modal-opinion .modal-body,
.modal-opinion .modal-header {
  padding: 15px 30px;
}
.modal-opinion .modal-body .value-group {
  align-items: normal;
  flex-direction: column;
  margin-bottom: 15px;
}
.modal-opinion .modal-body .value-group .regular-title {
  font-size: 16px;
  margin-bottom: 15px;
}
.modal-opinion .modal-body .value-group textarea {
  width: 100% !important;
  border: 1px solid #dbdbdb;
}
.value-radio {
  display: flex;
}
.value-radio .container {
  display: flex;
  flex-direction: column;
}

/* The container */
.container {
  display: block;
  position: relative;
  padding-left: 35px;
  margin-bottom: 12px;
  cursor: pointer;
  font-size: 22px;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

/* Hide the browser's default radio button */
.start-chk input {
  position: absolute;
  opacity: 0;
  cursor: pointer;
}

/* Create a custom radio button */
.checkmark {
  position: relative;
  top: 0;
  left: -15px;
  height: 44px;
  width: 44px;
  background: url("/images/start-off.jpeg") no-repeat;
}

/* On mouse-over, add a grey background color */
.start-chk:hover input ~ .checkmark {
  background-color: transparent;
}

/* When the radio button is checked, add a blue background */
.start-chk input:checked ~ .checkmark {
  background: url("/images/start-on.jpeg") no-repeat;
}

/* Create the indicator (the dot/circle - hidden when not checked) */
.checkmark:after {
  content: "";
  position: absolute;
  display: none;
}

/* Show the indicator (dot/circle) when checked */
.start-chk input:checked ~ .checkmark:after {
  display: block;
}

/* Style the indicator (dot/circle) */
.start-chk .checkmark:after {
  top: 9px;
  left: 9px;
  width: 8px;
  height: 8px;
  border-radius: 50%;
}

/* Header */
.header__logo {
  background-color: #1e2d7d;
  max-height: 90px;
}

.header__logo a {
  display: block;
}

.header__logo-image {
  width: 180px;
}

.padding--section {
  padding: 25px 0;
}
.border-line {
  border: 1px solid #e7e7e7;
}
/* Button */
.base-button {
  border-radius: 3px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0 40px;
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
  letter-spacing: 1px;
  cursor: pointer;
  text-align: center;
  word-break: keep-all;
  transition: all 0.3s;
}

.accept-btn {
  background-color: #38b449;
  color: #fff;
}
.accept-btn:hover {
  background-color: #1e2d7d;
}

.home-offer__content {
  padding-bottom: 50px;
}

.home-offer__sliders,
.search-bar-form {
  display: flex;
}

.search-bar-form {
  margin-bottom: 20px;
  margin-top: 40px;
}

.search-bar-form form {
  width: 100%;
}
.search-bar-form__input {
  width: 65%;
  float: left;
}
.search-bar-dropdown {
  width: 23%;
  float: left;
}
.search-bar-form__button {
  width: 10%;
  height: 42px;
  float: right;
}

/* Product Category Slide */
.sliders--title h3 {
  padding-bottom: 15px;
  margin: 20px 0;
  border-bottom: 1px solid #ddd;
}

.splide__list {
  display: flex;
}
.splide__slide {
  margin: 0 10px;
  text-align: center;
}

.splide__slide span {
  font-size: 16px;
  display: inline-block;
  color: #1e2d7d;
}

.splide__slide__container {
  display: flex;
  justify-content: center;
  margin-bottom: 15px;
  font-size: 14px;
}

/* Top Slider */
.top-offers__sliders ul {
  background: #fff;
  border-bottom: 1px solid #f5f5f5;
  border-top: 1px solid #f5f5f5;
}

.top-offers__sliders ul li {
  border-left: 1px solid #f5f5f5;
  border-right: 1px solid #f5f5f5;
  margin: 0;
  padding: 15px;
  max-width: 228px;
  width: 100%;
}

/* Offer Style */
.offer--card__slide img {
  max-height: 200px;
}

/* Offer Style Promo */
.offer--card__Promo img {
  max-height: max-content;
}

.offer--title h1 {
  font-weight: bold;
}
.offer--title a {
  display: block;
  margin: 30px 0px 20px;
  text-align: right;
}
.offer--title .col-lg-2,
.offer--title .col-lg-10 {
  padding-left: 0px;
  padding-right: 0px;
}
.offer--cards__bg {
  background: #fff;
  border: 1px solid #ccc;
  padding: 15px 20px;
}
.offer--cards {
  width: 50%;
  min-height: 300px;
  text-align: center;
}
.offer--cards h3 {
  margin-top: 20px;
}
.offer--cards h4 {
  margin-top: 0px;
}
.offer--cards p {
  font-size: 18px;
  margin-top: 30px;
  color: #42494b;
}
.offer--cards a {
  display: block;
  margin-top: 15px;
  margin-bottom: 15px;
}
.sign-price,
.currency-price {
  vertical-align: middle;
  color: #cf3917;
}
.currency-price {
  font-size: 24px;
  color: #cf3917;
  padding: 10px 0;
}
.cent-price {
  vertical-align: sub;
  margin-left: -5px;
  color: #cf3917;
}

/* Providers Slider */
.providers-slide__content {
  width: 210px;
  height: 210px;
  display: flex;
  margin-bottom: 30px;
}
.providers-slide__content img {
  border-radius: 100px;
}
.btn-transparent {
  padding: 5px 0px;
  font-size: 0.7em;
  border: 0px;
  color: #213f99;
  text-transform: capitalize;
}
.related-products {
  margin-bottom: 30px;
}
.related-products h3 {
  padding-bottom: 15px;
  margin: 20px 0;
  border-bottom: 1px solid #ddd;
}
</style>


// WEBPACK FOOTER //
// product-detail.vue?622732ae